<template>
    <div>
        <HeadCommon></HeadCommon>
        <div class="main">
            <div class="head_bg">
                <img src="../img/contact_us-bg.png" alt="">
                <div class="text">
                    <p style="color: #fff;">联系我们</p>
                    <span></span>
                </div>
            </div>
            <div class="form">
                <div class="title">
                    <h2>—— 联系方式 ——</h2>
                </div>
                <div class="container flex-aic">
                    <div class="address">
                        <h2>{{ name }}</h2>
                        <div class="item">
                            <div class="icon">
                                <img src="../img/a1.png" alt="">
                            </div>
                            <div class="text">
                                <p>地址：</p>
                                <span>{{ us_address }}</span>
                            </div>
                        </div>
                        <div class="item">
                            <div class="icon">
                                <img src="../img/a2.png" alt="">
                            </div>
                            <div class="text">
                                <p>电话：</p>
                                <span>{{ us_phone }}</span>
                            </div>
                        </div>
                        <div class="item">
                            <div class="icon">
                                <img src="../img/a3.png" alt="">
                            </div>
                            <div class="text">
                                <p>邮箱：</p>
                                <span>{{ us_mail }}</span>
                            </div>
                        </div>
                        <div class="item">
                            <div class="icon">
                                <img src="../img/a4.png" alt="">
                            </div>
                            <div class="text">
                                <p>QQ号：</p>
                                <span>{{ us_qq }}</span>
                            </div>
                        </div>
                        <div class="item">
                            <div class="icon">
                                <img src="../img/a5.png" alt="">
                            </div>
                            <div class="text">
                                <p>微博号：</p>
                                <span>{{ us_wb }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="message">
                        <h2>在线留言</h2>
                        <!-- <div class="input">
                            <p>姓名</p>
                            <input type="text" v-model="userinfo.name">
                            <div v-if="!this.userinfo.name===''" style="width: 100px;height: 20px;line-height: 20px; text-align: center; margin-top: 14px;">请输入姓名</div>
                        </div>
                        <div class="input">
                            <p>电话</p>
                            <input type="text" v-model="userinfo.phone" >
                        </div>
                        <div class="input">
                            <p>留言</p>
                            <textarea v-model="userinfo.message" ></textarea>
                        </div> -->
                      

                                <!--登录表单-->
                                <!-- el-form > el-form-item > el-input -->
                                <el-form ref="form" :model="userinfo" :rules="rules">
                                    
                                    <el-form-item prop="name"  >
                                        <p>姓名</p>
                                        <el-input v-model="userinfo.name" />
                                    </el-form-item>
                                    <el-form-item prop="phone" >
                                        <p>电话</p>
                                        <el-input v-model="userinfo.phone" />
                                    </el-form-item>
                                    <el-form-item prop="message">
                                        <p>留言</p>
                                        <el-input type="textarea" v-model="userinfo.message"></el-input>
                                    </el-form-item>
                                    <el-form-item class="btn">
                                        <el-button style="width: 160px;background-color: #08CFDE;    border-color:#08CFDE" type="primary" @click="getuserInfo">提交</el-button>
                                    </el-form-item>
                                </el-form>

                        <!-- <div class="btn" @click="getuserInfo">提交</div> -->
                    </div>

                </div>
            </div>
            <div id="map-img">
                <MapContainer></MapContainer>
            </div>
        </div>
        <FootCommon></FootCommon>
    </div>
</template>
  
<script>
import HeadCommon from '@/components/HeadCommon.vue';
import FootCommon from '@/components/FootCommon.vue';
//   import FuWen from "@/components/FuWen.vue";
import { contactList, getuserInfo } from "@/api/contact";
import MapContainer from "@/components/MapContainer.vue";
export default {
    name: 'ContactS',
    components: {
        HeadCommon,
        FootCommon,
        //   FuWen,
        MapContainer,
    },
    data() {
        return {
            name: '',
            us_address: '',
            us_phone: '',
            us_mail: '',
            us_qq: '',
            us_wb: '',
            userinfo: {
                name: '',
                phone: '',
                message: ''
            },
            rules: {
                name: [
                    { required: true, message: '请输入用户名', trigger: 'blur' }
                ],
                phone: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { pattern: /^1[3-9][0-9]{9}$/, message: '请正确输入手机号格式', trigger: 'blur' }
                ],
                message: [
                    { required: true, message: '请输入内容', trigger: 'blur' }
                ]
            },
        }
    },

    created() {
        this.contactList()
    },
    methods: {
        // 地址相关
        async contactList() {
            const { data } = await contactList()
            // console.log(data);
            this.name = data.name
            this.us_address = data.us_address
            this.us_phone = data.us_phone
            this.us_mail = data.us_mail
            this.us_qq = data.us_qq
            this.us_wb = data.us_wb
        },
        //留言相关
        // async getuserInfo() {
        //     const res = await getuserInfo(this.userinfo)
        //     console.log(res);
        //     this.userinfo.name = ''
        //     this.userinfo.phone = ''
        //     this.userinfo.message = ''
        // }
        getuserInfo() {
            this.$refs.form.validate(async isOk => {
                console.log(isOk)
                if (isOk) {
                    const res = await getuserInfo(this.userinfo)
                    console.log(res);
                    this.userinfo.name = ''
                    this.userinfo.phone = ''
                    this.userinfo.message = ''
                }
            })
        }


    }
}

</script>
  <!-- <script src=""></script> -->
  
<style>
@import '../style/contact_us.css'
</style>